import { render, staticRenderFns } from "./AuthorInput.vue?vue&type=template&id=639157d2"
import script from "./AuthorInput.vue?vue&type=script&lang=ts"
export * from "./AuthorInput.vue?vue&type=script&lang=ts"
import style0 from "./AuthorInput.vue?vue&type=style&index=0&id=639157d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./AuthorInput.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports